import { normalizeOrderForPrint } from "./printNormalizerForinPrepration";

const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

export default async function preprationItemPrint(orderDetails = {}) {
  const { meta, items } = normalizeOrderForPrint(orderDetails);

  return `
    <!DOCTYPE html>
    <html dir="rtl" lang="ar">
    <head>
      <meta charset="UTF-8" />
      <style>
        @page { size: 80mm auto; margin: 0; }
        html, body {
          margin: 0;
          padding: 0;
          background: #fff;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .receipt {
          font-family: 'Cairo', Arial, sans-serif;
          width: 80mm;
          padding: 10px;
          margin: 0 auto;
          color: #000;
          direction: rtl;
          text-align: right;
          box-sizing: border-box;
        }
        .header {
          margin-bottom: 8px;
          padding-bottom: 7px;
          border-bottom: 1.5px dashed #000;
          font-size: 14px;
          font-weight: 900;
          line-height: 1.7;
        }
        .header-row {
          display: flex;
          justify-content: space-between;
          gap: 8px;
        }
        .header-label {
          white-space: nowrap;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
        }
        th, td {
          padding: 7px 3px;
          text-align: right;
          vertical-align: top;
          border-bottom: 1.5px dashed #000;
          overflow-wrap: anywhere;
          line-height: 1.7;
        }
        th {
          font-size: 13px;
          font-weight: 900;
        }
        td {
          font-size: 15px;
          font-weight: 800;
        }
        .quantity {
          text-align: center;
          white-space: nowrap;
        }
      </style>
      <script>
        async function waitForAssets() {
          try {
            if (document.fonts && document.fonts.ready) {
              await document.fonts.ready;
            }
          } catch (e) {}

          await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));
        }

        window.__waitForAssets = waitForAssets;
      </script>
    </head>
    <body>
      <div class="receipt">
        <div class="header">
          <div class="header-row">
            <span class="header-label">رقم الطلب:</span>
            <span>${escapeHtml(meta.orderNumber)}</span>
          </div>
          <div class="header-row">
            <span class="header-label">نوع الطلب:</span>
            <span>${escapeHtml(meta.orderType)}</span>
          </div>
          <div class="header-row">
            <span class="header-label">وقت الطباعة:</span>
            <span>${escapeHtml(meta.printTime)}</span>
          </div>
        </div>
        <table>
          <colgroup>
            <col style="width: 32%;" />
            <col style="width: 15%;" />
            <col style="width: 26%;" />
          </colgroup>
          <thead>
            <tr>
              <th>اسم الصنف / المشروب</th>
              <th>الكمية</th>
              <th>الملاحظة</th>
            </tr>
          </thead>
          <tbody>
            ${items
              .map(
                (item) => `
                  <tr>
                    <td>${escapeHtml(item.name)}</td>
                    <td class="quantity">${escapeHtml(item.quantity)}</td>
                    <td>${escapeHtml(item.note)}</td>
                    <!-- <td>${escapeHtml(item.addedAt)}</td> -->
                  </tr>
                `
              )
              .join("")}
          </tbody>
        </table>
      </div>
    </body>
    </html>
  `;
}
